import { inject, Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AppUser, LG_USER_INFO, ServerGatewayBase } from "@logex/framework/lg-application";

import {
    AuthorizationExtendedPermission,
    OrganizationIdentifier,
    MRDM_AUTH_API_URL,
    AuthorizationProfile
} from "./mrdm-auth-api.types";

@Injectable({
    providedIn: "root"
})
export class MrdmAuthApiService extends ServerGatewayBase {
    baseUrl = inject<string>(MRDM_AUTH_API_URL);

    constructor() {
        super();
        this._setBaseUrl(this.baseUrl);
    }

    getProfile(): Observable<AuthorizationProfile> {
        return this._get<AuthorizationProfile>("api/v4/user/profile");
    }

    searchPermissions(
        params: {
            applicationInstances?: string[];
            products?: string[];
            organizations?: string[];
            organizationIdentifierType?: OrganizationIdentifier;
        } = {}
    ): Observable<AuthorizationExtendedPermission[]> {
        params.applicationInstances = params.applicationInstances ?? [];
        params.products = params.products ?? [];
        params.organizations = params.organizations ?? [];
        params.organizationIdentifierType = params.organizationIdentifierType ?? "Cic";
        return this._post<AuthorizationExtendedPermission[]>("api/v4/user/permissions/search", {
            body: { ...params }
        });
    }
}
